import {Space, Tag, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";

const Dot = ({color}) => (
    <span
        style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: color
        }}
    />
);

/**
 * Kullanıcı grid'inin "Çevrimiçi" hücresi. Kaynak DB değil, uygulama loglarıdır (app_logs):
 * presence yalnızca seçilen pencerede API'ye istek atmış kullanıcılarda dolu gelir.
 *
 * Hücre TEK SATIRDIR ve tek bilgi verir: çevrimiçi mi değil mi. "3 dakika önce", IP, son istek
 * yolu gibi ayrıntılar satırı iki katına çıkarıp listeyi okunmaz hâle getirdiği için tooltip'te.
 */
export default function UserPresenceCell({presence})
{
    const {t} = useTranslation();

    if (!presence)
        return (
            <Space size={4}>
                <Dot color={'#d9d9d9'}/>
                <span style={{color: 'var(--text-2)'}}>{t('Offline')}</span>
            </Space>
        );

    // Aynı hesabın aynı pencerede birden çok IP/cihazdan gelmesi paylaşılan hesap işaretidir.
    const shared = presence.ipCount > 1 || presence.deviceCount > 1;

    const detail = (
        <Space direction={'vertical'} size={0}>
            <span>{moment(presence.lastSeen).fromNow()}</span>
            <span>{moment(presence.lastSeen).format('YYYY-MM-DD HH:mm:ss')}</span>
            {presence.ip && <span>{presence.ip}</span>}
            {presence.clientId && <span>{presence.clientId}</span>}
            {presence.lastPath && <span style={{fontFamily: 'monospace'}}>{presence.lastPath}</span>}
            <span>{presence.requestCount} {t('requests')}</span>
        </Space>
    );

    return (
        <Tooltip title={detail}>
            <Space size={4}>
                <Dot color={'#52c41a'}/>
                <span>{t('Online')}</span>
                {shared && (
                    <Tag color={'orange'} style={{marginInlineEnd: 0}}>
                        {presence.ipCount} IP · {presence.deviceCount}
                    </Tag>
                )}
            </Space>
        </Tooltip>
    );
}
